import { Dialog, Stack, Text } from '@backyard-ui/core';

import { algolia } from '@/infra/tracking/algolia';
import { useSellers } from '@/presenters/hooks/catalog';
import { useProductStore } from '@/presenters/store/catalog/product';
import { useGlobalStore } from '@/presenters/store/global';

import { Disclaimer } from '../Disclaimer';

import { Item } from './Item';

export default function ModalitiesModal() {
  const regionName = useGlobalStore((state) => state.session?.regionName);
  const productId = useProductStore((store) => store.product._id);
  const { data: shipments, isFetched: isFetchedShipments } = useProductStore(
    (store) => store.shipments
  );

  const { data: sellers } = useSellers(productId);

  if (sellers?.length === 0 || !isFetchedShipments) {
    return null;
  }

  return (
    <Dialog.Root hasScroll>
      <Dialog.Trigger asChild>
        <Text
          UNSAFE_className="cursor-pointer"
          size="sm"
          color="green-700"
          align="left"
          onClick={() => {
            algolia.sendPdpClickEvent();
          }}
        >
          <strong>Clique aqui</strong> para ver outras formas de frete para{' '}
          <strong>{regionName}</strong>
        </Text>
      </Dialog.Trigger>

      <Dialog.Content>
        <Dialog.CloseButton />

        <Dialog.Title>
          <Stack direction="column" spacing="1">
            <Text size="2xl" color="black" weight="bold">
              Formas de frete para {regionName}
            </Text>
            <Text size="sm" color="gray-700">
              Confira todas as opções de entrega disponíveis para seu CEP
            </Text>
          </Stack>
        </Dialog.Title>

        <Dialog.Description>
          <Stack direction="column" spacing="4">
            {sellers?.map((seller, index) => (
              <div key={index} data-testid="seller-item">
                <Item
                  shopName={seller.shop.name}
                  shipment={shipments[seller.id]}
                />
              </div>
            ))}

            <Disclaimer />
          </Stack>
        </Dialog.Description>
      </Dialog.Content>
    </Dialog.Root>
  );
}
